import { TFunction } from 'i18next'
import Authorization from '../Authentication/Authorization'
import AppDetail from '../pages/apps/AppDetail'
import AppRestService from '../rest/AppRestService'
import RESTProtectionConfigurationRestService from "../../adapter/restencryption/services/RESTProtectionConfigurationRestService"


class AppService {
  async getApps() {
    const apps: any[] = await AppRestService.get()

    return apps.map((app) => {
      const props = { appId: app.id }
      return {
        path: '/apps/' + app.id,
        title: app.name,
        permissions: Authorization.apps.view,
        component: AppDetail,
        app,
        props,
      }
    })
  }

  getByID(id: number) {
    return AppRestService.getById(id)
  }

  getDefinitions() {
    return AppRestService.getDefinitions()
  }

  getDefinitionByType(type: string) {
    return AppRestService.getDefinitionByType(type)
  }

  async getAppsByTemplate(template: string, setApps?: React.Dispatch<any>) {
    if (setApps) {
      const apps = await AppRestService.getByTemplate(template)
      setApps(apps)
    } else {
      return AppRestService.getByTemplate(template)

    }
  }

  async createApp(app: any, t: TFunction, setSubTabs: React.Dispatch<any>) {
    try {
      const editedApp = await AppRestService.create(app)
      if (setSubTabs) {
        const subtabs = await new AppService().getApps()
        setSubTabs(subtabs)
      }
      return t('app.createAppSuccess', { name: editedApp.name })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateApp(app: any, t: TFunction, setApp: React.Dispatch<any>) {
    try {
      const editedApp = await AppRestService.update(app)
      if (setApp) {
        const updatedApp = await AppRestService.getById(app.id)
        setApp(updatedApp)
      }
      return t('app.editAppSuccess', { name: editedApp.name })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async deleteApp(app: any, t: TFunction, setSubTabs?: React.Dispatch<any>) {
    try {
      if (app.type === t('restprotection.type')) {
        await RESTProtectionConfigurationRestService.deleteByAppId(app.id)
      }
      await AppRestService.delete(app.id)
      if (setSubTabs) {
        const subtabs = await new AppService().getApps()
        setSubTabs(subtabs)
      }
      return t('app.deleteAppSuccess', { name: app.name })
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default new AppService() as AppService
